import { GET_NAC_AUTOMATION_LOGS, GET_NAC_AUTOMATION_DETAILS_BY_RITM, GET_NAC_AUTOMATION_EVENTS_BY_RITM } from "./actionTypes";

const initialState = {
    nacAutomationLogs : [],
    totalRecords: 0,
    nacAutomationLogsErrorMessage : null,
    nacAutomationDetailsbyRitm : [],
    nacAutomationDetailsbyRitmErrorMessage: null,
    nacAutomationEventsbyRitm: [],
    nacAutomationEventsbyRitmErrorMessage: null
}

const nacAutomationReducer = (state = initialState, action = {type: ""}) => {
    switch (action.type) {
        case GET_NAC_AUTOMATION_LOGS.SUCCESS:
            let { eventList, totalRecords } = action.payload;
            return {
                ...state,
                nacAutomationLogs : eventList,
                totalRecords: totalRecords,
                nacAutomationLogsErrorMessage: null,
            }

        case GET_NAC_AUTOMATION_LOGS.ERROR:
            return {
                ...state,
                nacAutomationLogs: [],
                totalRecords: 0,
                nacAutomationLogsErrorMessage: action.payload,
            }

        case GET_NAC_AUTOMATION_DETAILS_BY_RITM.SUCCESS:
            return {
                ...state,
                nacAutomationDetailsbyRitm: action.payload,
                nacAutomationDetailsbyRitmErrorMessage: null
            }

        case GET_NAC_AUTOMATION_DETAILS_BY_RITM.ERROR:
            return {
                ...state,
                nacAutomationDetailsbyRitm: [],
                nacAutomationDetailsbyRitmErrorMessage: action.payload
            }

        case GET_NAC_AUTOMATION_EVENTS_BY_RITM.SUCCESS:
            return {
                ...state,
                nacAutomationEventsbyRitm: action.payload,
                nacAutomationEventsbyRitmErrorMessage: null
            }

        case GET_NAC_AUTOMATION_EVENTS_BY_RITM.ERROR:
            return {
                ...state,
                nacAutomationEventsbyRitm: [],
                nacAutomationEventsbyRitmErrorMessage: action.payload
            }

        default:
            return {
                ...state
            }

    }

}

export default nacAutomationReducer;